import type { ScreenSchema } from './types';

// Course title content (course title, subtitle) comes from the Pinia course store,
// not screen-level YAML fields. managesOwnSectionAudio: true prevents uc-screen's
// generic watcher from also firing — audio is instead triggered by the GSAP
// animation callback (playAudio) which passes the store-derived text via overrideText.
const courseTitleSchema: ScreenSchema = {
  template: 'course-title',
  managesOwnSectionAudio: true,
  slots: {}
};

export default courseTitleSchema;
